import { Title1, Body1, makeStyles, Image } from "@fluentui/react-components";

const useStyles = makeStyles(
  {
    pageContainer: {
      padding: "5rem",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center"
    }
  }
);

export function NoSuchPage() {
  const styles = useStyles();

  return (
    <>
      <div className={styles.pageContainer}>
        <Image src="/images/webfail.svg" alt="404 icon" style={{ maxWidth: "80px", width: "100%" }}></Image>
        <Title1>404: No Such Page</Title1>
        <Body1>We couldn't find the page you're looking for.</Body1>
      </div>
    </>
  );
}
